import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import type {RouteObject} from '@github-ui/react-router'

import {CommitEntrypointFuture, CommitPathEntrypointFuture} from './Commit'
import {buildCommitPathRoute} from './commit-path-route'
import {buildCommitRoute} from './commit-route'
import {CommitsEntrypointFuture, CommitsRefEntrypointFuture} from './Commits'
import {buildCommitsLayoutRoute} from './commits-layout-route'
import {buildCommitsRefRoute} from './commits-ref-route'
import {buildCommitsRoute} from './commits-route'
import {CommitsLayout} from './CommitsLayout'

/** Builds the repo-scoped commits routes for either the standalone or repo app builder. */
export function createCommitsRoutes(appBuilder: DataRouterApplicationBuilder<string>): RouteObject[] {
  return [
    buildCommitsLayoutRoute(appBuilder).toRoute({
      Component: CommitsLayout,
      children: [
        buildCommitsRoute(appBuilder).toRoute({Component: CommitsEntrypointFuture}),
        buildCommitsRefRoute(appBuilder).toRoute({Component: CommitsRefEntrypointFuture}),
        buildCommitRoute(appBuilder).toRoute({Component: CommitEntrypointFuture}),
        buildCommitPathRoute(appBuilder).toRoute({Component: CommitPathEntrypointFuture}),
      ],
    }),
  ]
}
